import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Flex, FlexAlignItems, FlexBehavior, FlexJustify } from 'react-magma-dom';
import { StyledLessonHeading } from '../../Styled';
import { LessonIcon } from '../LessonIcon';
import { LessonPageHeading } from '../../../types/lessons';

interface ILessonHeading extends LessonPageHeading {
  isStandalone?: boolean;
  isTooltipShown?: boolean;
  fontSize?: number;
  color?: string;
  linkColor?: string;
  padding?: string;
}

export const LessonHeading: React.FC<ILessonHeading> = props => {
  const { text, icon, isTooltipShown, isStandalone, fontSize, color, linkColor, padding } = props;

  return (
    <StyledLessonHeading withBorder={isStandalone} fontSize={fontSize} color={color} padding={padding}>
      <Flex
        behavior={FlexBehavior.container}
        alignItems={FlexAlignItems.center}
        justify={FlexJustify.spaceBetween}
        testId="lesson-heading"
      >
        <ReactMarkdown skipHtml={false}>{text}</ReactMarkdown>
        {icon && <LessonIcon icon={icon} isTooltipShown={isTooltipShown} color={linkColor} isCustom />}
      </Flex>
    </StyledLessonHeading>
  );
};
